import { render, staticRenderFns } from "./is_pcb_soft_board.vue?vue&type=template&id=12fceb01"
import script from "./is_pcb_soft_board.vue?vue&type=script&lang=js"
export * from "./is_pcb_soft_board.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports